import { useState, useEffect, useCallback, useMemo } from 'react'
import { ErrorConstant } from 'utility'
import { PermissionSettingService } from 'utility/services/permission'

export const GetPermissionList = (extraQueryParams = {}) => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const options = useMemo(
        () =>
            data.map(ele => ({
                value: ele.PermissionId,
                text: ele.PermissionName,
            })),
        [data],
    )

    const fetchData = useCallback(async () => {
        try {
            setLoading(true)
            setError('')

            const result = await PermissionSettingService.list({
                onlyActive: false,
            })
            setData(result)
        } catch (err) {
            setError(ErrorConstant.default)
        } finally {
            setLoading(false)
        }
    }, [extraQueryParams])

    useEffect(() => {
        fetchData()
    }, [])

    const refresh = () => {
        fetchData()
    }

    return { data, setData, error, loading, refresh, options }
}
